const domainName = 'dev.rcscbs.com';
export const environment = {
  production: false,
  domainName: domainName,
  listerApiBaseUrl: `https://lister-api.${domainName}/api`,
  imsApiBaseUrl: `https://inventory-api.${domainName}/api`,
  companyApiBaseUrl: `https://company-api.${domainName}/api`,
  companyWebBaseUrl: `https://company.${domainName}`,
  productionSystemWebBaseUrl: `https://productionsystem.${domainName}`,
  listerWebBaseUrl: `https://lister.${domainName}`,
  posUrl: `https://pos.${domainName}`,
};
